import React, { Component } from 'react';
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class MatStyle extends Component {
	render() {
		const {selectedmatBoard, matBoardPrice} = this.props;
		return (
			<tr>
				<th>Mat Style</th>
				<td>{selectedmatBoard.size > 0 ? Parser(selectedmatBoard.get('name')) : "None Selected"}</td>
				<td>{Constants.Currency + matBoardPrice}</td>
			</tr>
		);
	}
}
export default MatStyle;